import { createFileRoute } from '@tanstack/react-router'

import { paginaObrigatoria } from '@/lib/visoes'

import { PaginaComAbas } from '@/components/heimdall/pagina-com-abas'

import { AbaAcessos } from '@/features/pessoas-acessos/aba'
import { AbaEmailsCommit } from '@/features/pessoas-emails/aba'
import { AbaResumoDiario } from '@/features/pessoas-resumo/aba'
import { AbaTimes } from '@/features/pessoas-times/aba'

export const Route = createFileRoute('/$perfil/pessoas')({
  component: Tela,
})

/** Pessoas e times: acessos, times, e-mails de commit e resumo diário. Cada aba vem da pasta da sua peça. */
function Tela() {
  return (
    <PaginaComAbas
      pagina={paginaObrigatoria('pessoas')}
      abas={[
        { id: 'acessos', titulo: 'Acessos', conteudo: <AbaAcessos /> },
        { id: 'times', titulo: 'Times', conteudo: <AbaTimes /> },
        { id: 'emails', titulo: 'E-mails de commit', conteudo: <AbaEmailsCommit /> },
        { id: 'resumo', titulo: 'Resumo diário', conteudo: <AbaResumoDiario /> },
      ]}
    />
  )
}
